module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead6-13cedd0776313438f93b68f3daf05c97.jpg";